import { Component, inject, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { SidebarService } from './../../../../services/sidebar/sidebar.service';
import { NgComponentOutlet } from '@angular/common';
import { SidebarButton } from '../../model/sidebar-button.type';
import { AuthApiService } from '../../../../services/auth/auth-api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-sidebar-button',
  standalone: true,
  imports: [RouterLink, NgComponentOutlet],
  templateUrl: './sidebar-button.component.html',
  styleUrl: './sidebar-button.component.scss',
})
export class SidebarButtonComponent {
  #sidebarService = inject(SidebarService);
  #authService = inject(AuthApiService);
  #router = inject(Router);
  #toast = inject(ToastrService);
  user: unknown = null;

  @Input()
  value!: SidebarButton;

  switchSidebarDisplay(): void {
    this.#sidebarService.switchDisplay();
  }

  logout(): void {
    this.#authService.logout$().subscribe({
      next: () => {
        this.#toast.success('Vous êtes déconnecté !', 'Succès');
        this.#router.navigate(['']);
      },
      error: () => {
        this.#toast.error('La déconnexion a échoué.', 'Erreur');
      },
    });
  }

  handleClick(event: MouseEvent): void {
    this.switchSidebarDisplay();
    if (this.value.label === 'Se déconnecter') {
      event.preventDefault();
      this.logout();
    }
  }
}
